/**
 * Internal dependencies
 */
import './popup-trigger';
